var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"y-line",class:{
       bold: _vm.line.bold
 },style:(_vm.fillStyleForYLine(_vm.line))},[(_vm.line.showLabel)?_c('div',{staticClass:"value-left"},[_vm._v(_vm._s(_vm.line.label))]):_vm._e(),(_vm.line.showLabel)?_c('div',{staticClass:"value-right"},[_vm._v(_vm._s(_vm.line.label))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }